<template>
  <div class="before-head-nav">
    <span @click="homeIndex">
      <v-img
        :attachment-id="settings.WEBSITE_LOGO"
        :default-img="require('@/assets/img/logo-dj.png')"
      />
    </span>
    <div>
      <template v-for="(item, index) in list">
        <router-link
          v-if="item.visible && !item.blank"
          :key="index"
          :to="item.link"
          tag="span"
          active-class="active"
          >{{ item.title }}
        </router-link>
        <span
          v-if="item.visible && item.blank"
          :key="index"
          @click="toPage(item)"
          >{{ item.title }}</span
        >
      </template>
    </div>
    <!--        <router-link-->
    <!--            v-for="(item, index) in headerNav"-->
    <!--            :key="index"-->
    <!--            :to="item.url"-->
    <!--            tag="span"-->
    <!--            active-class="active"-->
    <!--        >{{ item.title }}-->
    <!--        </router-link>-->
  </div>
</template>

<script>
import { getNavigationList } from "@/api/settting";
import { mapGetters } from "vuex";
import VImg from "@/components/VImg";

export default {
  name: "HeaderNav",
  components: { VImg },
  data() {
    return {
      list: [
        {
          title: "首页",
          link: "/homeIndex",
        },
        {
          title: "场景",
          link: "/homeScenes",
        },
        {
          title: "动态",
          link: "/homeDynamic",
        },
        {
          title: "活动",
          link: "/homeActivity",
        },
        {
          title: "成果",
          link: "/homeResults",
        },
        {
          title: "知识云",
          link: "/homeKnowledge",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["settings"]),
  },
  methods: {
    loadData() {
      getNavigationList().then((res) => {
        this.list = res.data;
      });
    },
    homeIndex() {
      this.$router.push("/homeIndex");
    },
    toPage(item) {
      window.open(item.link);
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style lang="less" scoped>
.before-head-nav {
  display: flex;
  align-items: center;

  > span {
    > img {
      display: block;
    }
  }

  > div {
    display: flex;

    > span {
      height: 64px;
      line-height: 64px;
      margin-left: 40px;
      cursor: pointer;
      border-bottom: 2px solid transparent;

      &.active {
        border-color: #fff;
      }
    }
  }
}
</style>
